const MAINTENANCE = {
  title: 'Ops...',
  subtitle: 'Estamos temporariamente em manutenção',
  text: 'Tente novamente mais tarde',
}

export default MAINTENANCE
